import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=b6311cfc&scoped=true&"
import script from "./Friend.vue?vue&type=script&lang=js&"
export * from "./Friend.vue?vue&type=script&lang=js&"
import style0 from "./Friend.vue?vue&type=style&index=0&id=b6311cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6311cfc",
  null
  
)

export default component.exports